import { createClient } from "@supabase/supabase-js";

export const supabaseHsvCrm = createClient(
  "https://qhpcbijsfjhgajjuxcgp.supabase.co",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFocGNiaWpzZmpoZ2FqanV4Y2dwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzU3MzI1NzUsImV4cCI6MjA1MTMwODU3NX0.s7QqNe8Cm07PqsFSE1UM0IWL5vkCjCWo_qw6Zd7bULM",
);
